// extracted by mini-css-extract-plugin
export default {"signup":"signup_signup__FBdBr"};